<template>
    <div class="tw-container tw-m-auto tw-mt-32 md:tw-w-2/3 tw-p-4 tw-w-full">
      <div class="tw-relative tw-z-10 tw-font-sans md:tw-text-right tw-text-center md:tw-text-3xl tw-text-3xl tw-mr-4">
        <h1>{{selectedLanguage == 'US' ? en.title_3 : pt.title_3}}</h1>
      </div>
      <hr class="tw-relative tw-z-10 tw-border-dashed tw-border-sky-700 tw-mt-1">
      <div class="tw-relative tw-z-10 tw-grid tw-mx-auto md:tw-grid-cols-3 tw-grid-cols-2 tw-mt-4 tw-gap-4">
        <single v-for="(single, index) in singles" :single="single" :artist="artist" :spotifyArtist="spotifyArtist" :key="index" />
      </div>
      <!-- <img class="bg-cover" :src="single['album']['images'][0]['url']" alt=""> -->
    </div>
</template>

<script>
import Layout from '@/Shared/Layout2';
import EventBus from '@/eventbus';
import pt from "../../../../../lang/smartsite/layout_2/layout_2.js";
import Single from '@/components/single';


export default {
    mixins: [pt],
    layout: (h, page) => h(Layout, [page]),
    layout: Layout,
    props: ['artist', 'pageOptions', 'spotifyArtist', 'singles'],
    components: {Single},
    computed: {
      selectedLanguage() {
        return this.$page.props.lang;
        }
    },
    created(){
      EventBus.$emit('artist', {'artist': this.artist, 'pageOptions': this.pageOptions});
    }
}
</script>

<style scoped>

.wrapper {
  position: relative;
  width: 100%;
  margin: 0 auto;
}

.wrapper:hover img {
  opacity: .5;
}

.wrapper:hover .overlay {
  opacity: 1;
  transition: 0.4s;
}

img {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: 1s ease;
}

.overlay {
  opacity: 0;
}

.content {
  width: 91%;
  height: 91%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  overflow: hidden;
  background-color: rgba(0, 0, 0, 70%);
}

.align-icons {
  width: 100%;
  padding: 0 20%;
  text-align: center;
}

h1 {
  color: #d6d6d6;
}

.bg-cover {
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  bottom: 0;
  right: 0;
  background-position: 30% 45%;
  background-size: cover;
  z-index: 0;
}
    
</style>